import { isRef, ref, watch } from 'vue';
import { jsonCopyObject } from '@/helpers/objects';
import { diff } from 'deep-object-diff';

export default function useForm(model: any, { dependency = {} } = {}) {
  const initialFormModel = jsonCopyObject(model);

  const formModel = ref(jsonCopyObject(model));
  const copyFormModel = ref(jsonCopyObject(model));

  const changes = ref(false);
  const form = ref<any>(null);
  const isFormValid = ref(false);

  const setCopyFormModel = (value: any) => {
    copyFormModel.value = jsonCopyObject(value);
  };
  const cancelChanges = () => {
    formModel.value = jsonCopyObject(copyFormModel.value);
  };
  const toggleChanges = (value: any) => {
    changes.value = value;
  };

  const checkFormChanges = (value: any) => {
    // const isEqual = deepEqual(value, copyFormModel.value);
    const isEqual = !Object.keys(diff(value, copyFormModel.value)).length;

    if (isEqual !== !changes.value) {
      toggleChanges(!isEqual);
    }
  };

  const updateFormModel = (newFormModel: any) => {
    const newFormModelCopy = jsonCopyObject(newFormModel);

    Object.keys(initialFormModel).forEach((key) => {
      formModel.value[key] = newFormModelCopy[key] ?? initialFormModel[key];
    });
    setCopyFormModel(formModel.value);
  };

  const resetFormModel = () => {
    updateFormModel(initialFormModel);
    if (form.value) resetFormValidation();
  };
  const resetForm = () => {
    if (!form.value) throw new Error('Form field is empty');

    resetFormModel();
    form.value.reset();
  };
  const resetFormValidation = () => {
    if (!form.value) throw new Error('Form field is empty');

    form.value.resetValidation();
  };

  if (isRef(dependency)) {
    watch(dependency, (value) => value && updateFormModel(value), { deep: true, immediate: true });
  }

  watch(
    () => formModel.value,
    (value) => checkFormChanges(value),
    { deep: true }
  );

  return {
    form,
    changes,
    formModel,
    isFormValid,
    copyFormModel,
    resetForm,
    cancelChanges,
    toggleChanges,
    resetFormModel,
    updateFormModel,
    checkFormChanges,
    setCopyFormModel,
    resetFormValidation,
  };
}
